import { TestReport } from '@/components/test-results/TestResults.types';

export function removeSingleTopLevelSuiteIfNameIs(name: string, testReport: TestReport): TestReport {
  const hasOnlyOneTopLevelSuite = testReport.testSuites.length === 1;
  if (!hasOnlyOneTopLevelSuite) {
    return testReport;
  }

  const topLevelSuite = testReport.testSuites[0];
  const suiteNameMatches = topLevelSuite.name === name;
  if (!suiteNameMatches) {
    return testReport;
  }

  const suiteContainsTestCases = !!topLevelSuite.testCases?.length;
  if (suiteContainsTestCases) {
    return testReport;
  }

  return { testSuites: topLevelSuite.testSuites ?? [] };
}
